(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rider-team"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('mutu-rider-team')) {
  customElements.define('mutu-rider-team', class extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.bound = true;
      this.classList.add('mutu-riders--ready');
      this.addEventListener('toggle', (event) => {
        if (!event.target.matches('details.mutu-rider')) return;
        const active = this.querySelector('details.mutu-rider[open]');
        if (event.target.open) this.show(event.target);
        else if (!active) this.restore(event.target);
      }, true);
      this.addEventListener('click', (event) => {
        const back = event.target.closest('[data-rider-back]');
        if (back) back.closest('details').open = false;
      });
      this.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          const active = this.querySelector('details[open]');
          if (active) { event.preventDefault(); active.open = false; }
        }
      });
      this.addEventListener('shopify:block:select', event => {
        const detail = event.target.querySelector('details.mutu-rider');
        if (detail) detail.open = true;
      });
    }
    show(detail) {
      this.classList.add('mutu-riders--viewing');
      this.querySelectorAll('.mutu-riders__grid > li').forEach(li => {
        li.hidden = !li.contains(detail);
        const other = li.querySelector('details');
        if (other && other !== detail) { other.open = false; this.clearVideo(other); }
      });
      detail.querySelector('[data-rider-back]').focus({preventScroll:true});
      detail.scrollIntoView({block:'start',behavior:'instant'});
      const host = detail.querySelector('[data-instagram-url]');
      if (!host || host.childElementCount) return;
      let url;
      try { url = new URL(host.dataset.instagramUrl); } catch { return; }
      if (url.protocol !== 'https:' || !['instagram.com','www.instagram.com'].includes(url.hostname)) return;
      const match = url.pathname.match(/^\/(p|reel|tv)\/([A-Za-z0-9_-]+)\/?$/);
      if (!match) return;
      const block = document.createElement('blockquote');
      block.className = 'instagram-media';
      block.dataset.instgrmPermalink = 'https://www.instagram.com/' + match[1] + '/' + match[2] + '/';
      block.dataset.instgrmVersion = '14';
      const link = document.createElement('a');
      link.href = block.dataset.instgrmPermalink;
      link.textContent = host.dataset.fallback;
      link.target = '_blank'; link.rel = 'noopener noreferrer';
      block.append(link); host.append(block);
      const process = () => { if (window.instgrm) window.instgrm.Embeds.process(); };
      if (window.instgrm) { process(); return; }
      let script = document.querySelector('script[src="https://www.instagram.com/embed.js"]');
      if (!script) { script = document.createElement('script'); script.src = 'https://www.instagram.com/embed.js'; script.async = true; document.head.append(script); }
      script.addEventListener('load', process, {once:true});
    }
    clearVideo(detail) { const host=detail.querySelector('[data-instagram-url]'); if(host) host.replaceChildren(); }
    restore(detail) {
      this.clearVideo(detail);
      this.classList.remove('mutu-riders--viewing');
      this.querySelectorAll('.mutu-riders__grid > li').forEach(li=>{li.hidden=false;});
      detail.querySelector('summary').focus({preventScroll:true});
      detail.scrollIntoView({block:'nearest',behavior:'instant'});
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
